export default "__VITE_ASSET__Bx5PxOG3__"